import { Component, OnDestroy, Input, HostBinding } from '@angular/core';
import { AccordionComponent } from './accordion.component';

@Component({
  selector: 'mpf-accordion-item',
  templateUrl: './accordion-item.component.html',
  styleUrls: ['./accordion-item.component.scss']
})
export class AccordionItemComponent implements OnDestroy {
  private _isOpen = false;

  @Input() title: string;

  @Input() shortTitle: string;

  @Input() icon: string;

  @Input()
  @HostBinding('class.panel-open') // adds the class `panel-open` to the host based on isOpen prop
  set isOpen(value: boolean) {
    this._isOpen = value;
    if (value) {
      this.accordion.closeOthers(this);
    }
  }

  get isOpen() {
    return this._isOpen;
  }

  constructor(private accordion: AccordionComponent) {
    this.accordion.addItem(this);
  }

  ngOnDestroy() {
    this.accordion.removeItem(this);
  }

  toggleOpen(event: MouseEvent): void {
    event.preventDefault();

    if (!this.isOpen) {
      // wait until the panel is displayed and scroll to make it visible
      setTimeout(() => {
        const accordionHeader = event.target as HTMLElement;
        accordionHeader.scrollIntoView({ behavior: 'smooth' });
      }, 100);
    }

    this.isOpen = !this.isOpen;
  }
}



// WEBPACK FOOTER //
// /vercel/path0/src/app/components/accordion/accordion-item.component.ts